import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import { getAuth } from "../../utils";
import { type Wishlist, wishlist } from "../schemas/wishlist";

export const getAnonymousWishlistItemProps = z
  .object({
    wishlistToken: z.string(),
    wishlistId: z.string(),
    productId: z.string(),
  })
  .extend(requestConfig.shape);

export type GetAnonymousWishlistItemProps = z.infer<
  typeof getAnonymousWishlistItemProps
>;

export const getAnonymousWishlistItem = async (
  args: GetAnonymousWishlistItemProps,
): Promise<Wishlist> => {
  const {
    endpoint = env.ACCOUNT_SERVICE_URL,
    auth: Authorization = getAuth(),
    wishlistToken,
    wishlistId,
    productId,
  } = parseServiceInput(getAnonymousWishlistItemProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization,
  });
  if (wishlistToken) {
    headers.append("x-api-token", `Bearer ${wishlistToken}`);
  }

  const response = await fetch(
    `${endpoint}/v1/wishlist/anonymous/${wishlistId}/${productId}`,
    {
      method: "GET",
      headers,
    },
  );

  return parseServiceOutput(response, wishlist, {
    code: "MALFORMED_WISHLIST",
    message: "Wishlist is malformed",
  });
};
